export function Logo({ large }: { large?: boolean }) {
  return (
    <span className={`logo ${large ? 'large' : ''}`}>
      <img src="/icon.svg" alt="" width={large ? 44 : 28} height={large ? 44 : 28} />
      <span className="logo-word">ClassGuardian</span>
    </span>
  );
}
